var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dara-container',{staticClass:"d-flex justify-content-center align-items-center h-100"},[_c('div',{staticClass:"text-center h-50"},[_c('router-view',{key:_vm.$route.path})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }